import type { ReactNode } from "react";
import s from "./layout.module.css";

/** Standard page scaffold: a header row and a scrolling body. `flush` lets the body manage its own scrolling. */
export function Page({ title, actions, children, flush, before, narrow = true }: { title: ReactNode; actions?: ReactNode; children: ReactNode; flush?: boolean; before?: ReactNode; narrow?: boolean }) {
  return (
    <div className={s.page}>
      <div className={s.pageHeader}>
        {before}
        {typeof title === "string" ? <h1 className={s.pageTitle}>{title}</h1> : title}
        {actions}
      </div>
      {flush ? <div className={s.pageBodyFlush}>{children}</div> : <div className={s.pageBody}>{narrow ? <div className={s.content}>{children}</div> : children}</div>}
    </div>
  );
}
